module.exports = __webpack_public_path__ + "static/img/platform.e74b583d.png";